import React from "react";
import { Loader2, MapPinPlus, RotateCcw, X } from "lucide-react";
import { GEOCODE_STATE, canCreateFrom, popupRows } from "../../pages/journeys/mapPickModel";

// The small panel for a point picked on the map: what the point resolved to
// (state, city / town, area) and its exact coordinates, with "Create Journey"
// for people who may create journeys. Shown in the map popup on wide screens
// and as a bottom sheet on phones (TspMap decides where).
//
// Nothing is saved from here: "Create Journey" only opens the Add Journey form
// with this point, and closing forgets it.
//
//   point       { latitude, longitude }
//   geocode     { state, data, message, retry } (hooks/useTspReverseGeocode)
//   canCreate   the caller holds journeys.manage
//   onCreate()  open Add Journey for this point
//   onClose()
export default function TspMapPointPanel({ point, geocode, canCreate, onCreate, onClose }) {
  const { state, data, message, retry } = geocode;
  const loading = state === GEOCODE_STATE.loading;
  const rows = popupRows(point, loading ? null : data);
  const warn = [GEOCODE_STATE.partial, GEOCODE_STATE.notFound, GEOCODE_STATE.failed, GEOCODE_STATE.invalid, GEOCODE_STATE.forbidden].includes(state);

  return (
    <section className="tsp-point-panel" aria-label="Selected map location" data-testid="tsp-point-panel">
      <header className="tsp-point-panel-head">
        <h4 className="tsp-point-panel-title">
          <MapPinPlus size={15} aria-hidden="true" /> {canCreate ? "Create Journey" : "Selected location"}
        </h4>
        <button type="button" className="tsp-point-panel-close" onClick={onClose} aria-label="Close selected location">
          <X size={15} aria-hidden="true" />
        </button>
      </header>

      <dl className="tsp-popup-facts tsp-point-panel-facts" aria-busy={loading}>
        {rows.map((row) => (
          <React.Fragment key={row.key}>
            <dt>{row.label}</dt>
            <dd data-testid={`tsp-point-${row.key}`}>{row.value || (loading && row.key !== "latitude" && row.key !== "longitude" ? "…" : "—")}</dd>
          </React.Fragment>
        ))}
      </dl>

      <p className={`tsp-point-panel-note${warn ? " tsp-point-panel-note--warn" : ""}`} role="status" aria-live="polite" hidden={!loading && !warn}>
        {loading && <Loader2 size={13} className="tsp-spin" aria-hidden="true" />} {loading || warn ? message : ""}
      </p>

      <div className="tsp-point-panel-actions">
        {state === GEOCODE_STATE.failed && (
          <button type="button" className="tsp-btn tsp-btn-outline tsp-btn-sm" onClick={retry}>
            <RotateCcw size={13} aria-hidden="true" /> Try again
          </button>
        )}
        {canCreate && (
          <button type="button" className="tsp-popup-btn tsp-point-panel-create" onClick={onCreate} disabled={!canCreateFrom(state)}>
            {loading ? "Resolving location…" : "Create Journey"}
          </button>
        )}
      </div>
    </section>
  );
}
